export default __webpack_public_path__ + "static/media/MATERIAL.5b2d8a0a.png";